import { adminRoles } from '@/constants';
import { checkAndRedirectForOrgAdminAccess, getSelectedOrg } from '@/helpers';
import { hasAnyOrgRole } from '@/helpers/roles';
import { fetchInstruments } from '@/services/instruments';
import { useAppStore } from '@/stores/app';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/instruments/')({
  beforeLoad: ({ context, location }) => {
    const store = useAppStore.getState();
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;

    checkAndRedirectForOrgAdminAccess({
      context,
      location,
      selectedOrganization,
      adminRoles,
      redirect,
    });
  },
  loader: async ({ context }) => {
    // `undefined`, never `[]`, on every short-circuit below: InstrumentsPage maps a non-array
    // loader result to `initialData: undefined`, so nothing is seeded into the query cache. `[]`
    // would seed a false "this org has zero instruments" success that's fresh for
    // INSTRUMENTS_QUERY_STALE_TIME (5 min) and is indistinguishable from a real empty org.
    const selectedOrg = getSelectedOrg();
    if (!selectedOrg?.id) return undefined;

    // beforeLoad returns without throwing while auth is still PENDING (it can't redirect on an
    // undecided status), so the loader can still run in that window — gate the actual fetch here
    // too rather than relying solely on the route component's own render gate (issue #396).
    if (
      context.authentication.status !== 'AUTHENTICATED' ||
      !hasAnyOrgRole(context.authentication.user?.assumed_roles, selectedOrg.id, adminRoles)
    ) {
      return undefined;
    }

    return fetchInstruments(selectedOrg.id);
  },
});
